var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeveragedSynthStocksIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 639.3",
    style: {
      enableBackground: "new 0 0 800 639.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,8.3c-9.2,6-17,14.6-17,27V536c0,0-2,103.3,97.2,103.3h631.3c20,0,49.3-5.6,60.2-18.2 c6.3-7.2,11.3-16.4,11.3-27.3c0-11.1-5.2-21.3-11.6-29.7c-10.9-14.2-39.9-22.1-59.9-22.1l-559.8-1.8c-20.1-0.1-50.3,2.5-61.8-7 c-5.5-4.6-9.7-12.1-9.7-24.2v-81.5c0-20,15.5-41.2,34.6-47.2l126.5-39.7c19.1-6,47.4-0.8,63.2,11.5l144.3,113.2 c15.8,12.4,40.4,11.3,55-2.5L767.9,230c14.6-13.8,26.7-41.1,27-61.2l1.3-79.1c0.3-20-11.1-25-25.6-11.2l-246.9,237 c-14.5,13.9-39.2,15.4-55.3,3.4l-142-106.1c-16.1-12-44.4-16.3-63.3-9.7l-130.6,45.8c-18.9,6.6-34.3-4.2-34.4-24.3L97.4,67.5 C97.3,47.4,90.7,18,77,7.3S32.5-1.7,17,8.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeveragedSynthStocksIcon);
export default __webpack_public_path__ + "static/media/leveraged_synth_stocks_icon.1be33215c44d747bd8d79921fd5cccf7.svg";
export { ForwardRef as ReactComponent };